import Accordion from 'ui3/Accordion/Accordion';
import Text from 'ui3/Text/Text';
// Styles
import styles from './ProductDetailsAccordion.module.scss';

type ProductDetailsAccordionProps = {
  description: string;
  openedByDefault?: boolean;
};

const ProductDetailsAccordion = ({
  description,
  openedByDefault = false,
}: ProductDetailsAccordionProps) => {
  return (
    <Accordion
      title="Product Details"
      titleClassName={styles.title}
      isWhiteIcon
      openedByDefault={openedByDefault}
    >
      <Text variant="body2Regular" className={styles.description}>
        {description}
      </Text>
    </Accordion>
  );
};

export default ProductDetailsAccordion;
